import { gql } from "@apollo/client"

export const VerifyCode = gql`
  mutation VerifyCode($input: VerifyCodeInput!) {
    verifyCode(input: $input) {
      success
      errors
    }
  }
`

export const ResendCode = gql`
  mutation ResendCode($input: ResendCodeInput!) {
    resendCode(input: $input) {
      success
      retryAfterSeconds
      errors
    }
  }
`
